export const threadsItemCount = 30;
